export const reportConstant = {
    REPORT_DATA: "REPORT_DATA",
    REPORT_SELECTED_FILTERS:"REPORT_SELECTED_FILTERS"
};
